import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { MyProfileModalComponent } from '@features/user/my-profile-modal/my-profile-modal.component';
import { UserProfileModalComponent } from '@features/user/user-profile-modal/user-profile-modal.component';
import { UserTradeUrlModalComponent } from '@features/user/user-trade-url-modal/user-trade-url-modal.component';

export function provideUserModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'MyProfileModal', component: MyProfileModalComponent, requiresAuth: true }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'UserProfileModal', component: UserProfileModalComponent }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'UserTradeUrlModal', component: UserTradeUrlModalComponent, requiresAuth: true }, multi: true },
  ];
}
